/**
 * The font families the Activity Log export registers.
 *
 * They live beside the HTML renderer rather than with the export because the renderer has to
 * name the Latin one: no Arabic face on Google Fonts carries the arrow a change draws between
 * its old and new value, so that one glyph is asked for by name.
 */
export const PDF_FONT_FAMILY = 'AuditLog';
export const PDF_FONT_FAMILY_ARABIC = 'AuditLogArabic';

/** The arrow between two values, marked so the renderer can hand it a face that has one. */
export const CHANGE_ARROW_CLASS = 'osano-change-arrow';
